module.exports = __webpack_public_path__ + "static/media/ppe_eye_pro.7880d127.png";